import { z } from 'zod/v4';
import { VoucherTypeIds, VoucherTypeSetting } from './index.js';
// Selects voucher types in stored config (billing models, case voucher
// tables). Ids name specific types; settings name every type carrying that
// setting, which is how config reaches tenant-created types such as payment
// types. A voucher matches if either list names its type.
export const VoucherTypeMatcherSchema = z.object({
    voucherTypeIds: z.array(z.uuid()).optional(),
    settings: z.array(z.enum(VoucherTypeSetting)).optional(),
});
export const matchesVoucherType = (matcher, voucher) => (matcher.voucherTypeIds?.includes(voucher.voucherTypeId) ?? false) ||
    (voucher.setting != null &&
        (matcher.settings?.includes(voucher.setting) ?? false));
// An empty matcher selects nothing, so config treats it as "not set"
export const hasVoucherTypeMatch = (matcher) => (matcher.voucherTypeIds?.length ?? 0) > 0 ||
    (matcher.settings?.length ?? 0) > 0;
export const PAYMENT_TYPES = {
    settings: [VoucherTypeSetting.Payment],
};
// Deposit handling, billing and distribution treat every PAYMENT-setting
// voucher alike. The standard DEPOSIT type is one of them
export const isPayment = (voucher) => matchesVoucherType(PAYMENT_TYPES, voucher);
export const isCreditNote = (voucher) => voucher.voucherTypeId === VoucherTypeIds.CREDITNOTE;
//# sourceMappingURL=matcher.js.map